import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AuthService } from '../../services/auth.service';
import { InternalMessageService } from '../internal.message/internal.message.service';
import { MessageModel } from '../internal.message/model/message.model';
import { ProfileService } from '../profile/profile.service';
import { View } from '../../common/model/view';
import { MaintenanceMessageService } from '../maintenance.message/maintenance.message.service';
import { ScheduleService } from '../../common/schedule.service/schedule.service';
import { IScheduleJob } from '../../common/schedule.service/schedule.job.model';
import * as moment from 'moment';
import { PortalMessageService } from '../portal.message/portal.message.service';
import * as $ from 'jquery';
import { Router } from '@angular/router';
import { LocalStorageService } from '../../common';
import { SignalRService } from '../../services/signalr.service';
import { ConfigurationService } from '../../configuration/configuration.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.pug',
  styleUrls: ['./home.component.sass']
})
export class HomeComponent implements OnInit, OnDestroy {

  public isAuthorized: boolean;
  public isAuthorizedSubscription: Subscription;
  public isConnectedSubscription: Subscription;
  public maintenanceMessageSubscription: Subscription;

  public maintenanceMessage: MessageModel;
  public messages: MessageModel[];
  public portalMessages: MessageModel[];

  constructor(
    private authService: AuthService,
    private internalMessageService: InternalMessageService,
    private maintenanceMessageService: MaintenanceMessageService,
    private portalMessageService: PortalMessageService,
    private profileService: ProfileService,
    private intervalService: ScheduleService,
    private router: Router,
    private localStorage: LocalStorageService,
    private signalRService: SignalRService
  ) {
  }

  ngOnInit() {
    $('#loginModal').modal('hide');
    $('#unAuthModal').modal('hide');

    this.fetchMaintenanceMessages();
    this.fetchPortalMessages();

    this.isAuthorizedSubscription = this.authService.getIsAuthorized().subscribe(
      async (isAuthorized: boolean) => {
        if (isAuthorized) {
          const ru = this.authService.returnUrl;
          if (ru) {
            this.localStorage.remove(AuthService.unauthorizedReturnUrl);
            setTimeout(async () => await this.router.navigateByUrl(ru),1000);
          } else {
            this.fetchMessages();
          }
        }

        this.isAuthorized = isAuthorized;
      });

      this.isConnectedSubscription = this.signalRService.ConnectionEvents.subscribe(ce => {
        if (this.maintenanceMessageSubscription) {
          this.maintenanceMessageSubscription.unsubscribe();
          this.maintenanceMessageSubscription = undefined;
        }

        if (ce) {
          this.maintenanceMessageSubscription = this.signalRService.addPublishCurrentMaintenanceMessageListener().subscribe(mm => { 
            this.maintenanceMessage = mm.upcomingMessage;
          });
        }
      }); 
  }

  private fetchMessages(): void {

    const filter = new View();
    filter.addOrUpdateFilter('Deleted', 'false');
    filter.addOrUpdateFilter('Visible', 'true');
    filter.addOrderBy('VisibleFrom', 'D');

    filter.Limit = 100;

    this.internalMessageService.getMessages(filter).then(messages => {
      this.messages = messages.value;
      this.messages.forEach(m => {
        if (m.createdBy) {
          this.profileService.getById(m.createdBy).then(p => {
            m.createdByFullName = p.fullName;
            m['email'] = p.emailAddress;
          });
        }
      });
    });
  }

  private async fetchMaintenanceMessages(): Promise<void> {

    const filter = new View();
    filter.addOrUpdateFilter('Deleted', 'false');
    filter.addOrUpdateFilter('VisibleUntil', moment().toISOString() + ';');
    filter.addOrderBy('VisibleFrom', 'A');
    filter.Limit = 1;

    const messages = await this.maintenanceMessageService.getMessages(filter);

    if (messages.value.length === 1) {
      this.maintenanceMessage = messages.value[0];

      this.maintenanceMessage.createdByFullName = 'Üzemeltetés';
    }
  }

  private async fetchPortalMessages(): Promise<void> {

    const filter = new View();
    filter.addOrUpdateFilter('Deleted', 'false');
    filter.addOrUpdateFilter('Visible', 'true');
    filter.addOrderBy('VisibleFrom', 'D');

    filter.Limit = 100;

    this.portalMessageService.getMessages(filter).then(messages => {
      this.portalMessages = messages.value;
    });
  }

  ngOnDestroy(): void {
    if (this.isAuthorizedSubscription) this.isAuthorizedSubscription.unsubscribe();
    if (this.isConnectedSubscription) this.isConnectedSubscription.unsubscribe();
    if (this.maintenanceMessageSubscription) this.maintenanceMessageSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/home/home.component.ts